// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var PageTitle = require("../../reason/common/PageTitle.bs.js");
var PageViews = require("../../reason/PageViews.bs.js");
var AuthSession = require("../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var ReactErrorBoundary = require("react-error-boundary");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var DashboardCardComponents__Tw = require("./DashboardCardComponents__Tw.bs.js");
var ChapterDashboard__PropertyStats = require("./ChapterDashboard__PropertyStats.bs.js");
var ChapterDashboard__BuyerNeedStats = require("./ChapterDashboard__BuyerNeedStats.bs.js");
var ChapterDashboard__ChapterMembers = require("./ChapterDashboard__ChapterMembers.bs.js");
var ChapterDashboard__UpcomingShowings = require("./ChapterDashboard__UpcomingShowings.bs.js");
var ChapterDashboard__BroadcastMessages = require("./ChapterDashboard__BroadcastMessages.bs.js");
var ChapterDashboardRelayPageQuery_graphql = require("../../__generated__/ChapterDashboardRelayPageQuery_graphql.bs.js");

var convertVariables = ChapterDashboardRelayPageQuery_graphql.Internal.convertVariables;

var convertResponse = ChapterDashboardRelayPageQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = ChapterDashboardRelayPageQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, ChapterDashboardRelayPageQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, ChapterDashboardRelayPageQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(ChapterDashboardRelayPageQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(ChapterDashboardRelayPageQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(ChapterDashboardRelayPageQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(ChapterDashboardRelayPageQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function ChapterDashboardRelayPage$default(props) {
  var isLoggedIn = AuthSession.useIsLoggedIn();
  var data = use(undefined, undefined, undefined, undefined);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(PageTitle.make, {
                      title: "Chapter Activity"
                    }),
                isLoggedIn ? JsxRuntime.jsx(PageViews.RecordPageView.make, {
                        page: PageViews.Page.makeChapterDashboardPage()
                      }) : null,
                JsxRuntime.jsx(MarkupHelpers.Container.make, {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
                                    children: [
                                      JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                                            text: "Properties"
                                          }),
                                      JsxRuntime.jsx(FragmentErrorBoundary.make, {
                                            fragmentDisplayName: "chapter dashboard property stats",
                                            children: JsxRuntime.jsx(React.Suspense, {
                                                  children: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__PropertyStats.make, {
                                                            query: data.fragmentRefs
                                                          })),
                                                  fallback: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__PropertyStats.LoadingState.make, {}))
                                                })
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
                                    children: [
                                      JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                                            text: "Client needs"
                                          }),
                                      JsxRuntime.jsx(FragmentErrorBoundary.make, {
                                            fragmentDisplayName: "chapter dashboard buyer need stats",
                                            children: JsxRuntime.jsx(React.Suspense, {
                                                  children: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats.make, {
                                                            query: data.fragmentRefs
                                                          })),
                                                  fallback: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__BuyerNeedStats.LoadingState.make, {}))
                                                })
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
                                    children: [
                                      JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                                            text: "Showings this week"
                                          }),
                                      JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
                                            FallbackComponent: (function (param) {
                                                return JsxRuntime.jsx(ChapterDashboard__UpcomingShowings.EmptyState.make, {});
                                              }),
                                            children: JsxRuntime.jsx(React.Suspense, {
                                                  children: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__UpcomingShowings.make, {
                                                            query: data.fragmentRefs
                                                          })),
                                                  fallback: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__UpcomingShowings.LoadingState.make, {}))
                                                })
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
                                    children: [
                                      JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                                            text: "Broadcast Messages"
                                          }),
                                      JsxRuntime.jsx(FragmentErrorBoundary.make, {
                                            fragmentDisplayName: "chapter dashboard broadcast messages",
                                            children: JsxRuntime.jsx(React.Suspense, {
                                                  children: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__BroadcastMessages.make, {
                                                            query: data.fragmentRefs
                                                          })),
                                                  fallback: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__BroadcastMessages.LoadingState.make, {}))
                                                })
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs(DashboardCardComponents__Tw.StyledContentBox.make, {
                                          children: [
                                            JsxRuntime.jsx(DashboardCardComponents__Tw.Header.make, {
                                                  text: "TAN members"
                                                }),
                                            JsxRuntime.jsx(FragmentErrorBoundary.make, {
                                                  fragmentDisplayName: "chapter dashboard chapter members",
                                                  children: JsxRuntime.jsx(React.Suspense, {
                                                        children: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__ChapterMembers.make, {
                                                                  query: data.fragmentRefs
                                                                })),
                                                        fallback: Caml_option.some(JsxRuntime.jsx(ChapterDashboard__ChapterMembers.LoadingState.make, {}))
                                                      })
                                                })
                                          ]
                                        }),
                                    className: "lg:col-span-2"
                                  })
                            ],
                            className: "grid grid-cols-1 lg:grid-cols-2 gap-6"
                          })
                    })
              ]
            });
}

var DashboardCardComponents;

var BuyerNeedStats;

var PropertyStats;

var ChapterMembers;

var BroadcastMessages;

var UpcomingShowings;

var $$default = ChapterDashboardRelayPage$default;

exports.DashboardCardComponents = DashboardCardComponents;
exports.BuyerNeedStats = BuyerNeedStats;
exports.PropertyStats = PropertyStats;
exports.ChapterMembers = ChapterMembers;
exports.BroadcastMessages = BroadcastMessages;
exports.UpcomingShowings = UpcomingShowings;
exports.Query = Query;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
